export class enviroment {
    public static urlBase(): string {        
        return "https://localhost:7011/";
    }
    public static demo(): boolean {        
        return true;
    }
}